import { Col, Row } from "react-bootstrap";
import { FiHome } from "react-icons/fi";
import {
  MdOutlineCategory,
  MdOutlineChat,
  MdOutlineSettingsPower,
  MdOutlineShoppingBag,
  MdOutlineDashboardCustomize,
} from "react-icons/md";
import { RiShieldUserLine } from "react-icons/ri";
import Link from "next/link";
import { Blob_Base_Url } from "../../utils/static";
import { withRouter } from "next/router";
import { useSelector } from "react-redux";
import { IKImage } from "imagekitio-react";

const AccountSidebar = ({ router }) => {
  return (
    <Col className="">
      <div className="account-sidebar bg-light rounded-8 py-4">
        <Profile />
        {Menus.map((x) => (
          <Menu {...x} router={router} />
        ))}
      </div>
    </Col>
  );
};

const Menu = ({ router, ...x }) => {
  const isActive = router.pathname == x.href;

  return (
    <Link href={x.href}>
      <a
        className={`menu-item ${
          isActive ? "bg-white text-primary" : "text-dark"
        }  px-4 py-3 border-bottom border-light`}
      >
        {x.icon}
        <p className="ps-3 fw-bold font-lg mb-0">{x.title}</p>
      </a>
    </Link>
  );
};

const Profile = () => {
  const { name, userName } = useSelector((s) => s.auth);
  return (
    <Row className="profile align-items-center border-bottom border-white px-3 py-2 mb-3">
      <Col sm="4">
        <IKImage
          transformation={[
            {
              height: 60,
              width: 60,
              v: Math.random(),
              crop: "cm-pad_resize",
            },
          ]}
          urlEndpoint={Blob_Base_Url}
          path={"profiles/default.jpeg"}
          className="bg-white h-auto w-100"
        />
      </Col>
      <Col sm="8 px-0">
        <p className="mb-0 text-grey font-lg">Hello,</p>
        <h2 className="fs-6 ls-1 fw-bold text-upercase text-truncate">
          {name || userName}
        </h2>
      </Col>
    </Row>
  );
};

const Menus = [
  {
    title: "My Orders",
    icon: <MdOutlineShoppingBag />,
    href: "/account/order",
  },
  {
    title: "My Profile",
    icon: <RiShieldUserLine />,
    href: "/account",
  },
  {
    title: "Services",
    icon: <MdOutlineCategory />,
    href: "/account/service",
  },
  {
    title: "My Address",
    icon: <FiHome />,
    href: "/account/address",
  },
  {
    title: "My Chats",
    icon: <MdOutlineChat />,
    href: "/chat",
  },
  {
    title: "Requests",
    icon: <MdOutlineDashboardCustomize />,
    href: "/account/request",
  },
  {
    title: "Sign Out",
    icon: <MdOutlineSettingsPower />,
    href: "https://api-main.dealsonopenbox.com/Signout",
  },
];

export default withRouter(AccountSidebar);
